<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
    <b-card>
      <h1>{{ $t("SMTP") }}</h1>
      <p>
        <b
          >{{ $t("SMTPPart1") }}
          <span v-if="preference == 1">{{ $t("ConfHubSMTP") }}</span>
          <span v-else>{{ $t("CustomSMTP") }}</span> {{ $t("SMTPPart2") }}</b
        >
        <br />
        <span v-if="preference == 1">{{ $t("SMTPMessage1") }}</span>
        <span v-if="preference == 0">{{ $t("SMTPMessage2") }}.</span>
      </p>
      <b-table
        class="smtpTable"
        :items="preferenceData"
        responsive
        :fields="fields"
        thead-class="hidden_header"
      >
        <template #cell(slug)="data">
          <div class="mt-2">
            <b>{{ $t(data.item.slug) }}</b>
          </div>
        </template>
        <template #cell(action)="data">
          <div class="walk-card">
            <b-form-checkbox
              class="col w-1/2"
              v-model="data.item.is_enabled"
              size="lg"
              name="cell_width"
              switch
              @change="changeVisiblity(data.item.is_enabled, data.index)"
            >
            </b-form-checkbox>
          </div>
        </template>
      </b-table>
      <form
        name="staff_form"
        method="post"
        v-on:submit.prevent="$event.preventDefault()"
        v-if="preference == 0"
      >
        <div class="vx-row">
          <!-- required -->
          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
          >
            <label class="vs-input--label"
              >{{ $t("ServerAddress") }} <span class="red">*</span></label
            >
            <b-form-input
              size="lg"
              :placeholder="$t('ServerAddress')"
              v-validate="{ required: true }"
              :data-vv-as="$t('ServerAddress')"
              name="server_address"
              v-model="staffs.server_address"
              class="w-full"
              @keydown.enter="checkForm"
            >
            </b-form-input>
            <span
              class="text-danger text-sm"
              v-show="errors.has('server_address')"
              >{{ errors.first("server_address") }}</span
            >
          </div>
          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
          >
            <label class="vs-input--label"
              >{{ $t("Port") }} <span class="red">*</span></label
            >
            <b-form-input
              size="lg"
              :placeholder="$t('Port')"
              v-validate="'required|numeric'"
              name="port"
              :data-vv-as="$t('Port')"
              v-model="staffs.port"
              class="w-full"
              @keydown.enter="checkForm"
            >
            </b-form-input>
            <span class="text-danger text-sm" v-show="errors.has('port')">{{
              errors.first("port")
            }}</span>
          </div>

          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
          >
            <label class="vs-input--label"
              >{{ $t("UserName") }} <span class="red">*</span></label
            >
            <b-form-input
              size="lg"
              :placeholder="$t('UserName')"
              v-validate="'required'"
              name="username"
              :data-vv-as="$t('UserName')"
              v-model="staffs.username"
              class="w-full"
              @keydown.enter="checkForm"
              :label-placeholder="$t('UserName')"
            ></b-form-input>
            <span class="text-danger text-sm" v-show="errors.has('username')">{{
              errors.first("username")
            }}</span>
          </div>

          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
          >
            <label class="vs-input--label"
              >{{ $t("Password") }} <span class="red">*</span></label
            >

            <b-form-input
              type="password"
              autocomplete="new-password"
              size="lg"
              :placeholder="$t('Password')"
              v-validate="'required|min:8|numbers|upCase|loCase'"
              :data-vv-as="$t('Password')"
              name="password"
              v-model="staffs.password"
              class="w-full"
              @keydown.enter="checkForm"
              @input="displayError"
            ></b-form-input>

            <span class="text-danger text-sm" v-show="errors.has('password')">{{
              errors.first("password")
            }}</span>
          </div>
          <!-- Must be a valid email -->
          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
          >
            <label class="vs-input--label"
              >{{ $t("SenderEmailAddress") }} <span class="red">*</span></label
            >
            <b-form-input
              size="lg"
              autocomplete="off"
              v-validate="'required|email'"
              :placeholder="$t('SenderEmailAddress')"
              name="sender_email_address"
              :data-vv-as="$t('SenderEmailAddress')"
              v-model="staffs.sender_email_address"
              class="w-full"
              @keydown.enter="checkForm"
            ></b-form-input>
            <span
              class="text-danger text-sm"
              v-show="errors.has('sender_email_address')"
              >{{ errors.first("sender_email_address") }}</span
            >
          </div>
        </div>

        <div class="vx-col" id="update">
          <b-button
            type="filled"
            @click.prevent="submitForm"
            class="mt-5 block border-primary"
            variant="primary"
            >{{ $t("Submit") }}</b-button
          >
          <router-link :to="'/company/dashboard'">
            <b-button
              id="cancel"
              type="border"
              variant="border"
              class="mt-5 br-20 pl-5 pr-5 border-primary text-primary"
            >
              {{ $t("Cancel") }}
            </b-button>
          </router-link>
        </div>
      </form>
    </b-card>
  </b-overlay>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

// For custom error message
import { Validator } from "vee-validate";

export default {
  components: {
    FormWizard,
    TabContent,
  },
  data() {
    return {
      staffs: [
        {
          server_address: "",
          port: "",
          username: "",
          sender_email_address: "",
          password: "",
        },
      ],
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      preference: 0,
      preferenceData: [],
      fields: [
        {
          key: "slug",
          sortable: false,
          sortDirection: "desc",
        },
        { key: "action", sortable: false },
      ],
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
        this.displayError();
      },
    },
  },
  created() {
    this.$validator.extend("upCase", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[A-Z]/g) !== null,
    });
    this.$validator.extend("numbers", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[0-9]/g) !== null,
    });
    this.$validator.extend("loCase", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[a-z]/g) !== null,
    });
    this.getSMTP();
    this.getSMTPpreference();
    this.loadLocale(this.$i18n.locale);
  },
  methods: {
    //display error
    displayError() {
      this.$validator.extend("upCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[A-Z]/g) !== null,
      });
      this.$validator.extend("numbers", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[0-9]/g) !== null,
      });
      this.$validator.extend("loCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[a-z]/g) !== null,
      });
    },

    errorClass(rule) {
      return {
        error: this.errors.firstByRule("password", rule),
      };
    },
    /**
     * validate phone number
     */
    onInput({ number, isValid, country }) {
      this.staffs.contact_number = number["international"];
    },

    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },

    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.addSMTP();
        }
      });
    },

    /**
     *  addSMTP method add all SMTP details
     **/
    addSMTP() {
      this.show = true;

      var data = {
        server_address: this.staffs.server_address,
        port: this.staffs.port,
        company_id: this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id,
        sender_email_address: this.staffs.sender_email_address,
        username: this.staffs.username,
        password: this.staffs.password,
      };

      this.$store
        .dispatch("AddSMTP", data)
        .then((res) => {
          this.show = false;

          this.$router.push("/company/settings/smtp").catch(() => {});
          this.$toasted.show(this.$t("SMTPUpdated"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : Add.vue | Function : addstaffs() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     *  getSMTP method get all SMTP details
     **/

    getSMTP() {
      this.show = true;
      this.$store
        .dispatch("GetSMTP", this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id)
        .then((res) => {
          this.show = false;
          if (res.data.data != null) this.staffs = res.data.data;
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getstaffs() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     * get SMTP preference
     */
    getSMTPpreference() {
      this.show = true;

      this.$store
        .dispatch("GetNotification", this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id)
        .then((res) => {
          this.notifications = res.data.data;
          this.notifications.map((element, index) => {
            if (this.notifications[index].slug == "smtp_preference") {
              this.notifications[index].is_enabled =
                element.is_enabled == 1 ? true : false;
              this.preference = element.is_enabled == true ? 1 : 0;
              this.preferenceData.push(this.notifications[index]);
            }
            console.log("this.preferenceData", this.preferenceData);
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getNotification() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     * open popup
     */
    changeVisiblity(value, index) {
      this.preference = value == true ? 1 : 0;
      var data = {
        slug: this.preferenceData[index].slug,
        is_enabled: value,
        company_id: this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id,
      };

      this.$store
        .dispatch("UpdateNotificationStatus", data)
        .then((res) => {
          console.log("data", res);

          this.$toasted.show(this.$t("NotificationSettingUpdate"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : Form.vue | Function : updateRooms() | Error :",
            error
          );
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>
<style lang="stylus">
#department {
  margin-top: 20px;
}
</style>
<style lang="stylus">
#update {
  display: inline-flex;
}

#cancel {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
}

.contact_number {
  padding: 8px !important;
}

#contact_label {
  margin-top: 15px;
}

.hidden_header {
  display: none;
}

.con-vs-tooltip {
  display: inline;
}

.smtpTable td {
  border: none;
}
</style>










